/**
 * Fields used behind the maps by the Collections APIs
 */
export class DataModelBase {
    [key: string]: unknown;

    _collection = '';
    _userid = '';
    _campaign = '';
    path: string | undefined = undefined;
}
